import {inject} from '@angular/core';
import {HttpInterceptorFn} from '@angular/common/http';
import {Store} from "@ngxs/store";
import {SessionState} from 'src/app/shared/state/session-state';

/**
 * This will include the JWT in all header requests going TO the server.
 */
export const authJwtInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(Store).selectSnapshot(SessionState.token);

  if (token) {
    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token)
    });
  }

  return next(req);
};
